const strings = {
  textModal: {
    editModalTitle: 'Editar Associação',
  },
}

export default strings
